











































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { bus } from '@/main'
import * as STdata from '../data/data.json'
const onClickaway = require('vue-clickaway');

import StatementTitle from './StatementTitle.vue'

@Component({
	directives: {
		onClickaway: onClickaway.directive
	},
	components: {
		StatementTitle
	},
    
})
export default class Statement extends Vue {
	@Prop({ required: true }) statementId!: number

	parties: any = (<any>STdata).default.parties
	statement: any = (<any>STdata).default.statements[this.$store.getters.currentStatementId]
	infoFieldOpen: null | 'vote' | 'info' = null
	voteHasBeenOpened: boolean = false
	votesInFavor: number = 0
	votesAgainst: number = 0
	openVoteMotivation: number = -1

	get voteResults(): {"inFavor": number, "against": number} {
		let votesInFavor = 0
		let votesAgainst = 0

		for (let i = 0; i < this.parties.length; i++) {
			if (this.parties[i].choices[this.$store.getters.currentStatementId].choice) {
				votesInFavor += this.parties[i].choices[this.statementId - 1].seats
			} else {
				votesAgainst += this.parties[i].choices[this.statementId - 1].seats
			}
		}

		if (this.statement.extraParties) {
			for (let i = 0; i < this.statement.extraParties.length; i++) {
				if (this.statement.extraParties[i].choice) {
					votesInFavor += this.statement.extraParties[i].seats
				} else {
					votesAgainst += this.statement.extraParties[i].seats
				}
			}
		}

		return {"inFavor": votesInFavor, "against": votesAgainst}
	}

    handleClickOutside(event: Event) {
        if (!this.$el.contains(event.target as Node)) {
            this.openVoteMotivation = -1;
        }
    }

	@Watch('infoFieldOpen')
	onInfoFieldOpenChange() {
		if (this.infoFieldOpen === 'vote') {

			setTimeout(() => {
				this.voteHasBeenOpened = true
				this.$store.dispatch('recordGraphSeen', this.statementId - 1)
			}, 50)

			if (this.$store.getters.graphSeenOnStatement[this.statementId - 1]) {
				this.votesInFavor = this.voteResults.inFavor
				this.votesAgainst = this.voteResults.against
			} else {
				const app = this

				function countInFavor() {
					setTimeout(() => {
						app.votesInFavor++

						if (app.votesInFavor < app.voteResults.inFavor) {
							countInFavor()
						}
					}, 5)
				}

				if (this.voteResults.inFavor > 0) {
					countInFavor()
				}

				function countAgainst() {
					setTimeout(() => {
						app.votesAgainst++

						if (app.votesAgainst < app.voteResults.against) {
							countAgainst()
						}
					}, 5)
				}

				if (this.voteResults.against > 0) {
					countAgainst()
				}
			}
		} else if (this.infoFieldOpen === 'info') {
			_paq.push(['trackEvent', 'userEvent', 'viewMoreInformation'])
		}
		this.openVoteMotivation = -1
	}

	@Watch('openVoteMotivation')
	onOpenVoteMotivationChange(): void {
		if (this.openVoteMotivation !== -1) {
			_paq.push(['trackEvent', 'userEvent', 'viewPartyMotivation'])
		}

    }
    
	toggleStatementVote() {
		if (this.infoFieldOpen !== 'vote') {
			this.infoFieldOpen = 'vote'
			_paq.push(['trackEvent', 'userEvent', 'viewVoteResults'])
		} else {
			this.infoFieldOpen = null
		}
	}

	openMotivation(index: number): void {
		if (this.openVoteMotivation === index) {
			Vue.nextTick()
				.then(() => this.openVoteMotivation = -1)
		} else {
			Vue.nextTick()
				.then(() => this.openVoteMotivation !== index ? this.openVoteMotivation = index : null)
		}
	}

	created() {
		bus.$on('changeDirection', (direction: 'next' | 'previous') => {
			this.infoFieldOpen = null
		})

		document.addEventListener('keydown', e => {
			if (e.keyCode === 27) {
				this.openVoteMotivation === -1 ? this.infoFieldOpen = null : this.openVoteMotivation = -1
			}
		})
	}
	mounted() {
		if (this.$store.getters.resultsSeenSinceStart) {
			this.infoFieldOpen = 'vote'
		}
        document.addEventListener('click', this.handleClickOutside);
	}

    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    }}
